import events, { MessageType } from "@/utils/events";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import BannerCard, { BannerCardProps } from "../BannerCard";
import BusinessButton from "../BusinessButton";

const bannerList: BannerCardProps[] = [
  {
    tagText: "模型技术服务",
    title: (
      <>
        <Text>画宇宙系列模型：</Text>
        <Text>强大的图像生成与图像处理 AI</Text>
      </>
    ),
    content: (
      <>
        <Box
          h="32px"
          w="fit-content"
          cursor="pointer"
          onClick={() => {
            window.open("https://github.com/carefree0910/carefree-creator", "_blank");
          }}
          sx={{
            "& img:nth-of-type(2)": {
              display: "none",
            },
            "&:hover img:nth-of-type(1)": {
              display: "none",
            },
            "& img:nth-of-type(1)": {
              display: "block",
            },
            "&:hover img:nth-of-type(2)": {
              display: "block",
            },
          }}
        >
          <Image
            h="32px"
            src="http://nolipix-js.nolibox.com/assets/creator/business/creator_star.png"
            mb="22px"
          />
          <Image
            h="32px"
            src="http://nolipix-js.nolibox.com/assets/creator/business/creator_star_hover.png"
            mb="22px"
          />
        </Box>
        <Text color="#4E5969">
          画宇宙系列模型，支持文生图、图生图、文生文、图像外延、图像局部处理、高清化、线稿生成正稿等诸多
          AIGC 功能。同时，可引入其他多源第三方模型，为客户提供更极致、更多样的 AIGC 创作体验。
        </Text>
      </>
    ),
    btnProps: {
      text: "售前咨询",
      theme: "blue",
      icon: "consult",
      name: "pop",
      onClick: () => events.emit(MessageType.BUSINESS_MODAL),
    },
    src: "http://nolipix-js.nolibox.com/assets/creator/business/image_1127.png",
  },
  {
    tagText: "模型微调和训练服务",
    title: (
      <>
        <Text>每个企业都可以拥有</Text>
        <Text>属于自己的 AIGC 大模型</Text>
      </>
    ),
    content: (
      <Text color="#4E5969" mt="20px">
        向通用模型中引入少量特定风格的数据对模型进行微调训练，输入文字描述即可生成该风格的设计图稿。每个企业都可以在画宇宙拥有专属的
        AI 模型，全天候响应企业内容生成需求。
      </Text>
    ),
    btnProps: {
      text: "售前咨询",
      theme: "blue",
      icon: "consult",
      name: "pop",
      onClick: () => events.emit(MessageType.BUSINESS_MODAL),
    },
    src: "http://nolipix-js.nolibox.com/assets/creator/business/image_1122.png",
    reverse: true,
  },
  {
    tagText: "面向专业场景的产品方案",
    title: (
      <>
        <Text>用无限画板创造无限创意</Text>
      </>
    ),
    content: (
      <Text color="#4E5969" mt="20px">
        「画宇宙」使用无限画板的 AIGC Web 端云应用，采用国产自研的无限画板交互和渲染技术，为 AIGC
        功能提供统一的创作空间和载体。
        <br />
        做为 AIGC 生产力工具，已服务例如 WEB 3.0
        内容社群、游戏策划、服装设计、家装设计等多个垂直领域企业。
      </Text>
    ),
    btnProps: {
      text: "售前咨询",
      theme: "blue",
      icon: "consult",
      name: "pop",
      onClick: () => events.emit(MessageType.BUSINESS_MODAL),
    },
    src: "http://nolipix-js.nolibox.com/assets/creator/business/image_1086.png",
  },
  {
    tagText: "面向流量运营的产品方案",
    title: (
      <>
        <Text>快速搭建应用，玩转 toC 流量</Text>
        <Text>帮助企业用 AIGC 赚钱</Text>
      </>
    ),
    content: (
      <Text color="#4E5969" mt="20px">
        以创意内容驱动增长，以 AIGC 互动新体验提升运营效果，为企业提供完整的 AIGC 流量运营解决方案。
        <br />
        已服务例如文创、新消费、汽车、家居、3C 等行业品牌，及腾讯会议等国民级应用。
      </Text>
    ),
    btnProps: {
      text: "售前咨询",
      theme: "blue",
      icon: "consult",
      name: "pop",
      onClick: () => events.emit(MessageType.BUSINESS_MODAL),
    },
    src: "http://nolipix-js.nolibox.com/assets/creator/business/image_1125.png",
    reverse: true,
  },
  {
    tagText: "API 服务",
    title: (
      <>
        <Text>开箱即用，</Text>
        <Text>将先进的图文 AI 引入您的产品</Text>
      </>
    ),
    content: (
      <Text color="#4E5969" mt="20px">
        稳定的 API 服务、API 开放平台在线自助管理、多种服务模式，满足各行业、各场景、各类用量的 AIGC
        需求。
      </Text>
    ),
    btnProps: {
      text: "售前咨询",
      theme: "blue",
      icon: "consult",
      name: "pop",
      onClick: () => events.emit(MessageType.BUSINESS_MODAL),
    },
    src: "http://nolipix-js.nolibox.com/assets/creator/business/image_1124.png",
  },
];

function FeaturePanel() {
  const onBtnClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const t = e.target as HTMLButtonElement;
    switch (t.name) {
      case "creator":
        window.open("https://creator.nolibox.com", "_blank");
        break;
      case "pop":
        events.emit(MessageType.BUSINESS_MODAL);
        break;
    }
  };
  return (
    <Box>
      {/* <Box>
        <Image src={"http://nolipix-js.nolibox.com/assets/creator/business/news_banner.jpg"} />
      </Box> */}
      <Flex
        h="320px"
        flexDir="column"
        fontFamily="Source Han Sans CN"
        align="center"
        bgImage="url('http://nolipix-js.nolibox.com/assets/creator/business/business_hero_bg.png')"
        bgSize="cover"
      >
        <Text
          bg="linear-gradient(110deg, #578CED, #2BD0DB 40%, #3959FF)"
          w="fit-content"
          bgClip="text"
          fontSize="70px"
          fontWeight={900}
          mt="50px"
        >
          全链路 AIGC 企业解决方案
        </Text>
        <Text fontSize="32px" color="#4E5969" fontWeight={600}>
          提供贴合企业需求的定制方案，算力 / 模型 / 产品，一站式解决
        </Text>
        <Flex mt="32px">
          <BusinessButton theme="blue" text="售前咨询" onClick={onBtnClick} icon="api" name="pop" />
          {/* <BusinessButton
            theme="white"
            text="体验个人版"
            onClick={onBtnClick}
            icon="planet"
            name="creator"
          /> */}
        </Flex>
      </Flex>
      {bannerList.map((banner) => (
        <BannerCard key={banner.src} {...banner} mt="48px" />
      ))}
    </Box>
  );
}

export default FeaturePanel;
